const DEBOUNCE_DELAY = 300;
const USER_MONITOR_DELAY = 60 * 1000;

export { DEBOUNCE_DELAY, USER_MONITOR_DELAY };
